import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header-left" }
const _hoisted_2 = { class: "count-badge" }
const _hoisted_3 = { class: "header-actions" }
const _hoisted_4 = { class: "popover-content" }
const _hoisted_5 = {
  key: 0,
  class: "history-actions"
}
const _hoisted_6 = {
  key: 1,
  class: "history-empty"
}
const _hoisted_7 = {
  key: 2,
  class: "history-list"
}
const _hoisted_8 = { class: "entry-header" }
const _hoisted_9 = { class: "entry-source" }
const _hoisted_10 = { class: "entry-key" }
const _hoisted_11 = { class: "entry-time" }
const _hoisted_12 = { class: "entry-change" }
const _hoisted_13 = { class: "old-value" }
const _hoisted_14 = { class: "new-value" }

import { ref, computed, onMounted, onUnmounted } from "vue";
import { useStateHistory } from "@/composables/useStateHistory";

const POPOVER_WIDTH = 320;
const POPOVER_HEIGHT = 400;

// Popover position style

export default /*@__PURE__*/_defineComponent({
  __name: 'StateHistoryPopover',
  setup(__props) {

const {
  stateHistory,
  isDetached,
  popoverPosition,
  attach,
  clearHistory,
  updatePopoverPosition,
  formatHistoryTime,
  formatValue,
} = useStateHistory();

const popoverRef = ref<HTMLElement | null>(null);

// Default dimensions
const popoverStyle = computed(() => {
  const pos = popoverPosition.value;
  
  if (pos.x === -1 || pos.y === -1) {
    // Default position: top-right area
    return {
      right: "20px",
      top: "80px",
      width: `${POPOVER_WIDTH}px`,
      maxHeight: `${POPOVER_HEIGHT}px`,
    };
  }

  return {
    left: `${pos.x}px`,
    top: `${pos.y}px`,
    width: `${POPOVER_WIDTH}px`,
    maxHeight: `${POPOVER_HEIGHT}px`,
  };
});

// Dragging logic
let isDragging = false;
let dragStartX = 0;
let dragStartY = 0;
let popoverStartX = 0;
let popoverStartY = 0;

const startDrag = (e: MouseEvent) => {
  if ((e.target as HTMLElement).closest(".header-btn")) return;

  isDragging = true;
  dragStartX = e.clientX;
  dragStartY = e.clientY;

  const popover = popoverRef.value;
  if (popover) {
    const rect = popover.getBoundingClientRect();
    popoverStartX = rect.left;
    popoverStartY = rect.top;
  }

  document.addEventListener("mousemove", onDrag);
  document.addEventListener("mouseup", stopDrag);
  document.body.style.userSelect = "none";
};

const onDrag = (e: MouseEvent) => {
  if (!isDragging) return;

  const deltaX = e.clientX - dragStartX;
  const deltaY = e.clientY - dragStartY;

  updatePopoverPosition(popoverStartX + deltaX, popoverStartY + deltaY);
};

const stopDrag = () => {
  isDragging = false;
  document.removeEventListener("mousemove", onDrag);
  document.removeEventListener("mouseup", stopDrag);
  document.body.style.userSelect = "";
};

onUnmounted(() => {
  document.removeEventListener("mousemove", onDrag);
  document.removeEventListener("mouseup", stopDrag);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "popover" }, {
      default: _withCtx(() => [
        (_unref(isDetached))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "state-history-popover",
              style: _normalizeStyle(popoverStyle.value),
              ref_key: "popoverRef",
              ref: popoverRef
            }, [
              _createElementVNode("div", {
                class: "popover-header",
                onMousedown: startDrag
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _cache[2] || (_cache[2] = _createElementVNode("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    width: "14",
                    height: "14"
                  }, [
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "12",
                      r: "10"
                    }),
                    _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
                  ], -1)),
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "title" }, "State History", -1)),
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(stateHistory).length), 1)
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    class: "header-btn",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(attach) && _unref(attach)(...args))),
                    title: "Reattach to panel"
                  }, [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      width: "14",
                      height: "14"
                    }, [
                      _createElementVNode("path", { d: "M15 3h6v6" }),
                      _createElementVNode("path", { d: "M10 14 21 3" }),
                      _createElementVNode("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" })
                    ], -1)
                  ]))])
                ])
              ], 32),
              _createElementVNode("div", _hoisted_4, [
                (_unref(stateHistory).length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("button", {
                        class: "clear-btn",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(clearHistory) && _unref(clearHistory)(...args)))
                      }, "Clear")
                    ]))
                  : _createCommentVNode("", true),
                (_unref(stateHistory).length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, " No state changes recorded yet "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([..._unref(stateHistory)].reverse(), (entry) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: entry.id,
                          class: "history-entry"
                        }, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(entry.source), 1),
                            _createElementVNode("span", _hoisted_10, "." + _toDisplayString(entry.key), 1),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(formatHistoryTime)(entry.timestamp)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(formatValue)(entry.oldValue)), 1),
                            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "arrow" }, "→", -1)),
                            _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(formatValue)(entry.newValue)), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
              ])
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})